import {dateEqual} from "./dateManipulation";

function isObject(object: any): boolean {
	return object != null && typeof object === "object";
}

function isDate(d: any): boolean {
	return d instanceof Date;
}


export function deepCopy(obj: Object, forceUTC = false): any{
	const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/; //> may need Z on end
	//parse dates if json to js obj from string 
	const reviver = (_key: string | number, value: any): Date => {
		if (typeof value === "string" && dateFormat.test(value)) {
			if(forceUTC && !value.includes("Z")){//> should investagate Z or +00:00
				value += "Z";
			}

			return new Date(value);
		}

		return value;
	};

	return JSON.parse(JSON.stringify(obj), reviver);
}

export function deepEqual(object1: any, object2: any): boolean {
	if(!object1 || !object2){
		return object1 === object2;
	}

	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (const key of keys1) {
		const val1 = object1[key];
		const val2 = object2[key];
		const areDates = isDate(val1) && isDate(val2);
		const areObjects = isObject(val1) && isObject(val2);
		if (
			(areDates && !dateEqual(val1, val2)) ||
        (areObjects && !deepEqual(val1, val2)) ||
        (!areObjects && val1 !== val2)
		) {
			return false;
		}
	}

	return true;
}


